import Chart from "react-apexcharts";
import React, { useEffect, useState } from "react";
import { getValueOrFallback, transformArrayToObject } from "utils/commonHelper";
import {
  ANNUAL_INCOMES,
  EDUCATION_LEVELS,
  LIVING_SITUATIONS,
  MARITAL_STATUSES,
  USER_GENDER,
} from "constant/staticData";

const AnalysisGraph = ({ rightChartData, type }) => {
  const [chartData, setChartData] = useState({
    series: [],
    labels: [],
    colors: [],
  });

  // const objectValue = transformArrayToObject(arrayValue, key, value);

  const lableObject = {
    Gender: transformArrayToObject(USER_GENDER, "value", "label"),
    "Education Level": transformArrayToObject(
      EDUCATION_LEVELS,
      "value",
      "label"
    ),
    "Living Situation": transformArrayToObject(
      LIVING_SITUATIONS,
      "value",
      "label"
    ),
    "Marital Status": transformArrayToObject(
      MARITAL_STATUSES,
      "value",
      "label"
    ),
    "Annual Income": transformArrayToObject(ANNUAL_INCOMES, "value", "label"),
  };

  useEffect(() => {
    if (rightChartData && Array.isArray(rightChartData)) {
      // Extract values, labels, and colors from the backend data
      const series = rightChartData?.map((item) => item?.value || 0);
      const labels = rightChartData?.map((item) =>
        item?.label
          ? lableObject[type]
            ? lableObject[type][item?.label]
            : item?.label
          : "---"
      );
      const colors = rightChartData?.map((item) => item?.colour);

      setChartData({ series, labels, colors });
    }
  }, [rightChartData]);

  const donutChartOptions = {
    chart: {
      type: "pie",
    },
    labels: chartData.labels,
    colors: chartData.colors,
    legend: {
      position: "bottom", // Default legend position
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            // width: 300,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <div className="_card">
      <div className="survey_chart">
        <h3>
          <span>Distribution by {type}</span>
          {/* <select>
            <option>Riyadh</option>
          </select> */}
        </h3>
        <div className="chart">
          <Chart
            type="pie"
            series={chartData.series}
            options={donutChartOptions}
          />
        </div>
      </div>
    </div>
  );
};

export default AnalysisGraph;
